import { cn } from '../lib/cn';

export interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export function Pagination({ page, totalPages, onPageChange, className }: PaginationProps) {
  if (totalPages <= 1) return null;

  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav aria-label="Paginación" className={cn('flex items-center justify-center gap-1', className)}>
      <button
        type="button"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        className="rounded-md border border-outline px-3 py-1.5 text-sm disabled:opacity-40"
      >
        Anterior
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          aria-current={p === page ? 'page' : undefined}
          onClick={() => onPageChange(p)}
          className={cn(
            'min-w-[2.25rem] rounded-md border px-2 py-1.5 text-sm',
            p === page
              ? 'border-primary bg-primary text-primary-foreground'
              : 'border-outline bg-white hover:bg-surface',
          )}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        className="rounded-md border border-outline px-3 py-1.5 text-sm disabled:opacity-40"
      >
        Siguiente
      </button>
    </nav>
  );
}
